{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/accordion",
	"title": "Accordion",
	"category": "design",
	"description": "Displays a group of accordion headings and associated expandable content.",
	"example": {},
	"supports": {
		"anchor": true,
		"html": false,
		"align": [ "wide", "full" ],
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"__experimentalDefaultControls": {
				"backgroundImage": true
			}
		},
		"color": {
			"background": true,
			"gradients": true
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		"spacing": {
			"padding": true,
			"margin": [ "top", "bottom" ],
			"blockGap": true
		},
		"shadow": true,
		"layout": true,
		"ariaLabel": true,
		"interactivity": true,
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"contentRole": true
	},
	"attributes": {
		"iconPosition": {
			"type": "string",
			"default": "right"
		},
		"showIcon": {
			"type": "boolean",
			"default": true
		},
		"autoclose": {
			"type": "boolean",
			"default": false
		},
		"headingLevel": {
			"type": "number",
			"default": 3
		},
		"levelOptions": {
			"type": "array"
		}
	},
	"providesContext": {
		"core/accordion-icon-position": "iconPosition",
		"core/accordion-show-icon": "showIcon",
		"core/accordion-heading-level": "headingLevel"
	},
	"allowedBlocks": [ "core/accordion-item" ],
	"textdomain": "default",
	"viewScriptModule": "@wordpress/block-library/accordion/view"
}
